import React, { useState, useEffect } from "react";
import { useSidebarTree } from "../hooks/useSidebarTree";
import KeyboardArrowRightRoundedIcon  from "@mui/icons-material/KeyboardArrowRightRounded";
import DragIndicator from "@mui/icons-material/DragIndicator";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

import MenuIcon from "@mui/icons-material/Menu";
import StarIcon from "@mui/icons-material/Star";

const Sidebar = ({ data, menuNm, onMenuClick }) => {
  const [openMenus, setOpenMenus] = useState({});
  const treeData = useSidebarTree(data);
  const [selectedMenuId, setSelectedMenuId] = useState(null);

  const addBtnData = useSelector((state) => state.user.addBtnData);

  const menuData = useSelector((state) => state.user.menuData);
  const myMenuData = useSelector((state) => state.user.myMenuData);

  const [activeTab, setActiveTab] = useState("MENU");

  const toggleMenu = (id) => {
    setOpenMenus((prev) => ({
      ...prev,
      [id]: !(prev[id] ?? false),
    }));
  };
  /*
  const parentMap = {};
  const treeDataFlat = {};

  const buildParentMap = (nodes, parent = null) => {
    nodes.forEach((node) => {
      parentMap[node.MENU_ID] = parent;
      treeDataFlat[node.MENU_ID] = node;
      if (node.children) buildParentMap(node.children, node);
    });
  };
  buildParentMap(treeData);

  const getMenuPath = (menuId) => {
    const path = [];
    let currentId = menuId;
    while (currentId) {
      const currentNode = treeDataFlat[currentId];
      if (currentNode) {
        path.unshift(currentNode.MENU_NM);
        currentId = parentMap[currentId]?.MENU_ID;
      } else break;
    }
    return path;
  };
  */

  const handleClick = (level, hasChildren, node) => {
    setSelectedMenuId(node.MENU_ID);
    if (hasChildren) {
      toggleMenu(node.MENU_ID);
    } else {
      //const pathTitles = getMenuPath(node.MENU_ID);

      // 추가 버튼리스트
      const addBtnList = addBtnData.filter(item => item.MENU_ID === node.MENU_ID);
      onMenuClick(
        node.MENU_ID,
        node.DISPLAY_PATH.split(" > "),  //pathTitles,
        node.PRGM_ID,
        node.PERM_ID,
        node.SYTM_FLAG_CD,
        node.PRGM_PATH,
        node.CMMNBTNPRINT,
        node.CMMNBTNADD,
        node.CMMNBTNDEL,
        node.CMMNBTNSAVE,
        node.CMMNBTNEXCELDOWN,
        node.CMMNBTNSEARCH,
        node.PARM,
        null,
        addBtnList
      );
    }
  };

  const getMenuNameChain = (menuData, targetMenuId, moduleCd) => {
    // 1. 대상 index 찾기
    const targetIndex = menuData.findIndex(
      (item) => item.MENU_ID === targetMenuId
    );

    if (targetIndex === -1) return [];

    const result = [];
    let currentLv = menuData[targetIndex].MENU_LV;

    // 2. 대상 메뉴부터 시작
    if (currentLv !== 0) {
      result.push(menuData[targetIndex].MENU_NM);
    }

    // 3. 이전 row를 거꾸로 탐색
    for (let i = targetIndex - 1; i >= 0; i--) {
      const item = menuData[i];

      if(item.MODULE_CD !== moduleCd) continue;
      // LV0 제외
      if (item.MENU_LV === 0) continue;

      // LV가 달라지는 순간 = 부모
      if (item.MENU_LV < currentLv) {
        result.push(item.MENU_NM);
        currentLv = item.MENU_LV;
      }

      // LV1까지 찾았으면 종료
      if (currentLv === 1) break;
    }

    // 4. LV 순서대로 정렬
    return result.reverse();
  };


  const handleFavClick = (node) => {
    setSelectedMenuId(node.MENU_ID);
    const findMenu = menuData.filter(item => item.MENU_ID === node.MENU_ID);
    if(findMenu && findMenu.length > 0) {
      // 추가 버튼리스트
      const menu = findMenu[0];
      const pathTitles = getMenuNameChain(menuData, node.MENU_ID, menu.MODULE_CD);

      const addBtnList = addBtnData.filter(item => item.MENU_ID === node.MENU_ID);
      onMenuClick(
        menu.MENU_ID,
        pathTitles,
        menu.PRGM_ID,
        menu.PERM_ID,
        menu.SYTM_FLAG_CD,
        menu.PRGM_PATH,
        menu.CMMNBTNADD,
        menu.CMMNBTNDEL,
        menu.CMMNBTNSAVE,
        menu.CMMNBTNEXCELDOWN,
        menu.CMMNBTNSEARCH,
        menu.PARM,
        null,
        addBtnList
      );
    }
  };  

  const LevelOneIcon = ({ active }) => (
    <div
      className={`
        flex items-center justify-center
        w-6 h-6
        rounded-md
        transition-all duration-200

        ${active
          ? "bg-[#e6f4ff] text-[#1677ff]"
          : "bg-transparent text-gray-400 group-hover:bg-[#e6f4ff] group-hover:text-[#1677ff]"
        }
      `}
    >
      <DragIndicator className="w-4 h-4" />
    </div>
  );  

  useEffect(()=>{
    setActiveTab("MENU");
  }, [menuNm]);  

  const renderFavorite = () => (
    <ul>
      {myMenuData.map((node) => (
        <li key={node.MENU_ID} className="mb-[2px]">
          <div
            className={`
              group flex items-center justify-between cursor-pointer
              px-3 py-2
              text-[13px]
              rounded-md
              transition-all
              hover:bg-[#fff7e6]
              hover:text-[#f5a623]
              ${
                selectedMenuId === node.MENU_ID
                  ? "bg-[#fff1cc] text-[#f5a623]"
                  : "text-gray-700"
              }
            `}
            onClick={() => handleFavClick(node)}
          >
            <span className="flex items-center gap-2 truncate">
              <span className="text-[#f5a623]">★</span>
              <span>{node.MENU_NM}</span>
            </span>
          </div>
        </li>
      ))}

      {myMenuData.length === 0 && (
        <div className="text-xs text-gray-400 px-3 py-6 text-center">
          즐겨찾기 메뉴가 없습니다
        </div>
      )}
    </ul>
  );  

  const renderTree = (nodes, level = 0, parentOpen = true) => {
    if (!parentOpen) return null;

    return (
      <ul
      >
        {/* className={level > 0 ? "pl-2 ml-1 border-l border-gray-200/60" : ""} */}
        {nodes.map((node) => {
          const isOpen = openMenus[node.MENU_ID] ?? false;
          const hasChildren = node.children?.length > 0;

          return (
            <li key={node.MENU_ID} className="mb-[2px]">
              {/* 메뉴 항목 

                ${level > 0
                  ? "pl-3 ml-2 border-l border-gray-200/70"
                  : ""
                }

              */}
            <div
              className={`
                group flex items-center justify-between cursor-pointer
                px-3 py-1 
                transition-all duration-200 ease-out
                hover:bg-[#f0f7ff] hover:text-[#1677ff]
                ${
                  level === 0
                    ? "font-medium text-[13.5px] text-gray-800"
                    : "text-[12.5px] text-gray-600 pl-3"
                }
                ${
                  selectedMenuId === node.MENU_ID
                    ? "bg-[#e6f4ff] text-[#1677ff]"
                    : ""
                }
              `}
                style={{
                  paddingLeft: level === 0 ? "8px" : `${8 + level * 10}px`,
                }}              
              onClick={() => handleClick(level, hasChildren, node)}
            >
             
                {/* 메뉴 텍스트 */}
                <span className="flex items-center gap-2 truncate leading-5">
                  {/*
                  {level === 0 && (
                    <LevelOneIcon active={selectedMenuId === node.MENU_ID} />
                  )}
                    */}
                  <span className="pl-[10px]">{level === 0?node.MENU_NM:"- " + node.MENU_NM}</span>
                </span>

                {/* 펼침 아이콘 */}

                {hasChildren && (
                  <motion.div
                    animate={{
                      rotate: isOpen ? 90 : 0,
                      scale: isOpen ? 1.08 : 1,
                    }}
                    transition={{
                      type: "spring",
                      stiffness: 260,
                      damping: 18,
                    }}
                    className="text-gray-400 group-hover:text-[#1677ff]"
                    style={{ transformOrigin: "50% 50%" }}
                  >
                    <KeyboardArrowRightRoundedIcon className="w-4 h-4" />
                  </motion.div>
                )}
{/*}
                {hasChildren && (
                  <KeyboardArrowRightRoundedIcon
                    fontSize="inherit"
                    className={`
                      w-4 h-4
                      text-gray-400
                      transform 
                      transition-transform duration-300
                      ease-[cubic-bezier(0.2,1.2,0.4,1)]

                      group-hover:text-[#1677ff]

                      ${
                        isOpen
                          ? "rotate-90 scale-115 text-[#1677ff]"
                          : "rotate-0 scale-100"
                      }
                    `}
                  />
                )}
                  {*/}
              </div>

              {/* 하위 메뉴 트리 - 슬라이드 애니메이션 추가 */}
              <div
                className={`
                  overflow-hidden
                  transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]
                  ${isOpen ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"}
                `}
              >
                {hasChildren && renderTree(node.children, level + 1, isOpen)}
              </div>
            </li>
          );
        })}
      </ul>
    );
  };
  //bg-gradient-to-b from-white to-[#fafbfc]
  return (
    
    <aside className="
      w-[240px]
      
      bg-gradient-to-b from-white via-[#fafcff] to-[#f5f8fc]
      border-r border-[#D1D5DB]
      px-2 py-2
      text-gray-800
      h-full
      overflow-auto
      pt-0
    "
    >
      <h3 className="
          mb-2
          h-[33px]
          flex items-center gap-2
          text-[14px]
          font-semibold
          text-gray-700
          tracking-wide
          pb-0
          bg-gray-100
          border-b border-gray-300
          -mx-2
          px-2
        "
        >
          {/* 왼쪽 여백 + 텍스트 */}
          <span className="ml-[20px] whitespace-nowrap c-[#1F2937]">
            {menuNm}
          </span>

          {/* 오른쪽 이미지 */}
          <img
            src="/images/Vector.png"
            alt="icon"
            className="ml-auto w-[15px] h-[15px]"
          />
      </h3>

          {/* 탭 영역 */}
          <div className="
            flex items-center justify-center gap-3
            bg-[#f1f4f9]
            rounded-lg
            p-[3px]
            mb-3
          ">
            <button
              onClick={() => setActiveTab("MENU")}
              className={`
                flex items-center gap-1
                px-3 py-1.5
                text-[12.5px]
                rounded-md
                transition-all
                ${activeTab === "MENU"
                  ? "bg-white text-[#1677ff] shadow-sm font-medium"
                  : "text-gray-500 hover:text-gray-700"}
              `}
            >
              <MenuIcon sx={{ fontSize: 16 }} />
              메뉴리스트
            </button>

            <button
              onClick={() => setActiveTab("FAVORITE")}
              className={`
                flex items-center gap-1
                px-3 py-1.5
                text-[12.5px]
                rounded-md
                transition-all
                ${activeTab === "FAVORITE"
                  ? "bg-white text-[#f5a623] shadow-sm font-medium"
                  : "text-gray-500 hover:text-gray-700"}
              `}
            >
              <StarIcon sx={{ fontSize: 16 }} />
              즐겨찾기
            </button>
          </div>



      {activeTab === "MENU" && renderTree(treeData)}
      {activeTab === "FAVORITE" && renderFavorite()}
    </aside>
  );
};

export default Sidebar;
